import Head from 'next/head';
import React from "react";

export default function MetaImage({image}) {
	return (
		<Head>
			<meta property="og:image" content={image}/>
		</Head>
	);
}